import React from 'react'
import "./App.css";
import './styles/main.scss'
import { Provider } from 'react-redux';
import { store } from './store';


import Routes from './layouts/Routes';


function App() {
  return (
    <Provider store={store}>
        <Routes/>
    </Provider>
  );
}

export default App;